// extracted by mini-css-extract-plugin
module.exports = {"loader-indicator":"DotLoading_loader-indicator__3owGG"};